import HBIcon from "@/components/HBIcon";
import uploadAccept from "@/constants/uploadAccept";
import { When } from "react-if";
import FilePicker from "../../../FilePicker";
import styles from "../index.module.less";
// import HBIcon from "../../../HBIcon";

export default function EmptyUploader(props) {
  const {
    onFilePicked,
    // onlyCreation,
    globalConfig,
    maxUploadAmount,
  } = props;

  return (
    <div className={styles.hasNoResources} style={{ paddingBottom: "24px" }}>
      <div className={styles.title}>上传采集</div>
      {/*{onlyCreation && (*/}
      {/*  <div className={styles.originalTip}>*/}
      {/*    <a*/}
      {/*      className={styles.text1}*/}
      {/*      href={"http://www.meisubq.com/copyright/register/edit"}*/}
      {/*      target={'_blank'} rel="noreferrer"*/}
      {/*    >*/}
      {/*      <HBIcon type={"ic_copyright1"} style={{ fontSize: 18 }} />*/}
      {/*      &nbsp;登记版权作品*/}
      {/*    </a>*/}
      {/*    <div className={styles.text2}>*/}
      {/*      跳转至花瓣美素操作，作品会同步到默认花瓣原创画板&nbsp;*/}
      {/*      <a*/}
      {/*        target={'_blank'}*/}
      {/*        href={*/}
      {/*          "https://faq.huaban.com/faq/dci-copyright-registration/#e698afe590a6e58fafe4bba5e79bb4e68ea5e59ca8e7be8ee7b4a0e4b88ae4bca0e4bd9ce59381efbc8ce5b9b6e799bbe8aeb0efbc9f"*/}
      {/*        } rel="noreferrer"*/}
      {/*      >*/}
      {/*        了解更多*/}
      {/*      </a>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*)}*/}
      <FilePicker
        accept={uploadAccept}
        className={styles.filePicker}
        onPick={onFilePicked}
        maxAmount={maxUploadAmount}
        multiple
      />
      <When condition={globalConfig?.gaodingProGuide}>
        <a
          className={styles.gaodingPro}
          target="_blank"
          href={globalConfig?.gaodingProUrl}
          rel="noreferrer"
          data-gd-click="button_click"
          data-gd-expose="resource_loc_expose"
          data-button-name={`去${globalConfig?.gaodingProText}上传`}
          data-resource-title={`去${globalConfig?.gaodingProText}上传`}
          data-resource-type="图片"
          data-resource-id={0}
        >
          <div className={styles.container}>
            <div className={styles.icon}>
              <img
                src="//cdn.dancf.com/fe-assets/20230817/7f17246a61d709e962e29e664e5f9b72.png"
                alt={globalConfig?.gaodingProText}
              />
            </div>
            <div className={styles.info}>
              <div className={styles.desc}>
                去{globalConfig?.gaodingProText}上传
              </div>
              <div className={styles.subdesc}>
                支持拖拽文件夹上传，单次上传不限数量
              </div>
            </div>
            <div className={styles.arrow}>
              <HBIcon type="launch" />
            </div>
          </div>
        </a>
      </When>
    </div>
  );
}
